import { Fragment } from "react";
import { BiSolidTruck } from "react-icons/bi";
import { FaUserPlus } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa6";
import { FiPhoneCall } from "react-icons/fi";
import { IoTicket } from "react-icons/io5";
import { LuLogIn } from "react-icons/lu";
import { Link } from "react-router-dom";
import useSharedData from "../../../../../../hooks/useSharedData";
import style from "./Profile.module.css";

function Profile() {
  const { isAuthed, user, isAgent } = useSharedData();
  const token = localStorage.getItem("token");
  const city = user?.address?.city?.faName ?? "";
  const fullName = user?.name + " " + (user?.family ?? "");

  return (
    <div>
      {isAuthed && (
        <div className={"pt-2 " + style.imgBox}>
          <img src="/avatar.png" alt="" className={style.img} />
          <div className="pe-2">
            <p className="mb-0 text-end fs-6 fw-semibold">{fullName}</p>
            <p className="mb-0 text-end">{city}</p>
          </div>
        </div>
      )}
      <div className={"my-3 bg-avaex-second " + style.phone}>
        <span className="ms-2">
          <FiPhoneCall />
        </span>
        <Link to="tel:02182802466" className="text-white">
          021-82802466
        </Link>
      </div>

      <ul className={style.list}>
        {isAgent && (
          <li>
            <Link
              to={`https://agent.avaex.ir/tokenLogin/${token}`}
              className="text-decoration-none"
            >
              <span>
                <BiSolidTruck />
              </span>
              <span>پنل نمایندگی</span>
            </Link>
          </li>
        )}

        {isAuthed && (
          <Fragment>
            <li>
              <Link to="/messages" className="text-decoration-none">
                <span>
                  <FaEnvelope />
                </span>
                <span>پیام ها</span>
              </Link>
            </li>

            <li>
              <Link to="/account/tickets" className="text-decoration-none">
                <span>
                  <IoTicket />
                </span>
                <span>تیکت ها</span>
              </Link>
            </li>
          </Fragment>
        )}

        {isAuthed === false && !isAgent && (
          <Fragment>
            <li>
              <Link to="/login" className="text-decoration-none">
                <span>
                  <LuLogIn />
                </span>
                <span>ورود</span>
              </Link>
            </li>
            <li>
              <Link to="/register" className="text-decoration-none">
                <span>
                  <FaUserPlus />
                </span>
                <span>ثبت نام</span>
              </Link>
            </li>
          </Fragment>
        )}
      </ul>

      <div className={style.line} />
    </div>
  );
}

export default Profile;
